import { Text } from "@chakra-ui/react"


export const TitleModalPainel = ({title}: { title: string | undefined }) => {
    return (
        <>
            {
                title ? <Text fontWeight={'bold'} fontSize={'large'} >{title}</Text> : null
            }
        </>
    )
}